import React, { useState } from 'react';
import NoImage from '../../img/noinage.png';
import { IoImage } from 'react-icons/io5';
import { FiCamera } from 'react-icons/fi';
import styles from './AddProduct.module.css';
import AltTagModal from './sections/AltTagModal';

const ImageUploader = ({
    images,
    onImageSet,
    onRemoveImage,
    onUpdateAltText,
    error,
    productName,
}) => {
    const [altModalOpen, setAltModalOpen] = useState(false);
    const [selectedImageIndex, setSelectedImageIndex] = useState(null);
    return (
        <div className={styles['AddProduct-media-container']}>
            {/* Image requirements */}
            <div
                className={`${styles['AddProduct-media-requirements']} ${
                    error ? styles['error-field'] : ''
                }`}
            >
                <div className={styles['AddProduct-media-requirements-icon']}>
                    <FiCamera />
                </div>
                <div className={styles['AddProduct-media-requirements-text']}>
                    <strong>Image requirements:</strong> 1000×1000px minimum, up
                    to 3MB
                </div>
            </div>

            <div className={styles['AddProduct-media-grid']}>
                {images.map((image, index) => (
                    <div
                        key={image.id}
                        className={styles['AddProduct-media-item']}
                    >
                        {index === 0 && (
                            <div
                                className={
                                    styles['AddProduct-media-main-badge']
                                }
                            >
                                Main Image
                            </div>
                        )}
                        <div
                            className={
                                styles['AddProduct-media-image-container']
                            }
                        >
                            <img
                                src={image.url || NoImage}
                                alt={
                                    image.altText ||
                                    `Product image ${index + 1}`
                                }
                                className={styles['AddProduct-media-image']}
                            />
                            <button
                                onClick={() => onRemoveImage(image.id)}
                                className={styles['AddProduct-media-remove']}
                                type="button"
                            >
                                ×
                            </button>
                        </div>
                        <div className={styles['AddProduct-media-actions']}>
                            <div
                                className={
                                    styles['AddProduct-media-actions-row']
                                }
                            >
                                <label
                                    className={
                                        styles['AddProduct-media-upload-button']
                                    }
                                >
                                    <input
                                        type="file"
                                        onChange={(e) =>
                                            onImageSet(e, image.id)
                                        }
                                        className={
                                            styles[
                                                'AddProduct-media-file-input'
                                            ]
                                        }
                                        accept="image/*"
                                    />
                                    Replace image
                                </label>
                                <button
                                    onClick={() => {
                                        setSelectedImageIndex(index);
                                        setAltModalOpen(true);
                                    }}
                                    className={
                                        styles['AddProduct-media-alt-button']
                                    }
                                    type="button"
                                    title="Edit alt text for SEO"
                                >
                                    <IoImage />
                                    Alt Text
                                </button>
                            </div>
                            {image.altText && (
                                <div
                                    className={
                                        styles['AddProduct-media-alt-preview']
                                    }
                                >
                                    <strong>Alt:</strong> {image.altText}
                                </div>
                            )}
                        </div>
                    </div>
                ))}

                {/* Add new image */}
                {images.length < 5 && (
                    <div className={styles['AddProduct-media-add']}>
                        <label className={styles['AddProduct-media-add-label']}>
                            <input
                                type="file"
                                onChange={(e) => onImageSet(e, null)}
                                className={
                                    styles['AddProduct-media-file-input']
                                }
                                accept="image/*"
                            />
                            <div
                                className={styles['AddProduct-media-add-icon']}
                            >
                                +
                            </div>
                            <div
                                className={styles['AddProduct-media-add-text']}
                            >
                                Add image
                            </div>
                        </label>
                    </div>
                )}
            </div>

            {/* Alt Tag Modal */}
            <AltTagModal
                isOpen={altModalOpen}
                onClose={() => {
                    setAltModalOpen(false);
                    setSelectedImageIndex(null);
                }}
                image={
                    selectedImageIndex !== null
                        ? images[selectedImageIndex]
                        : null
                }
                onSave={onUpdateAltText}
                imageIndex={selectedImageIndex}
                productName={productName}
            />
        </div>
    );
};

export default ImageUploader;
